import { useState, useEffect, useCallback } from 'react';
import * as React from 'react';

import { FadeInOutAnimation } from "./FadeInOut.styles";








export const FadeInOut = ({
  active = false,
  animationDurationInMs = 300,
  className,
  children }) =>
{
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    if (active) {
      setIsRendered(active);
    }
  }, [active]);

  const handleAnimationEnd = useCallback(() => {
    if (!active) {
      setIsRendered(false);
    }
  }, [active]);

  return isRendered ? /*#__PURE__*/
  React.createElement(FadeInOutAnimation, {
    className: className,
    active: active,
    animationDurationInMs: animationDurationInMs,
    onAnimationEnd: handleAnimationEnd },

  children) :

  null;
};